import TitleBar3 from './titleBar3';
export default TitleBar3;
